import axios, { AxiosError } from 'axios';
import config from '../config';
import EventEmitter from 'events';

const redirectEmitter = new EventEmitter();

// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

// intercepting to capture errors
axios.interceptors.response.use(
    function (response: any) {
        return response.data ? response.data : response;
    },
    function (error: AxiosError<{ message: string; statusCode: number }>) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;
        if (error.response) {
            if (error.response.status) {
                switch (error.response.status) {
                    case 500:
                        message = 'Internal Server Error';
                        break;
                    case 401:
                        message = error.response.data.message || 'Unauthorized';
                        redirectEmitter.emit('unauthorized');
                        break;
                    case 404:
                        message =
                            'Sorry! the data you are looking for could not be found';
                        break;
                    default:
                        message =
                            (error.response.data as any).message ||
                            (error.response.data as any).error;
                }
            }
        } else {
            message = "Sorry! Couldn't get the error";
        }

        return Promise.reject(message);
    }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

class APIClient {
    /**
     * Fetches data from given url
     */
    get = (url: string, params?: {}) => {
        return axios.get(url, params);
    };

    /**
     * post given data to url
     */
    create = (url: string, data?: {}) => {
        return axios.post(url, data);
    };

    /**
     * Updates data
     */
    update = (url: string, data?: {}) => {
        return axios.put(url, data);
    };

    /**
     * Updates Attribute
     */
    updateAttribute = (url: string, data?: {}) => {
        return axios.patch(url, data);
    };

    /**
     * Delete
     */
    delete = (url: string, config?: {}) => {
        return axios.delete(url, { ...config });
    };

    /*
   file upload update method
  */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }
        // const config = {
        //   headers: {
        //     ...axios.defaults.headers,
        //     "content-type": "multipart/form-data",
        //   },
        // };
        // return axios.put(url, formData, config);
    };

    /*
   file upload post method
   */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }
        // const config = {
        //   headers: {
        //     ...axios.defaults.headers,
        //     "content-type": "multipart/form-data",
        //   },
        // };
        return axios.post(url, formData);
    };
}

const getLoggedinUser = () => {
    const user = localStorage.getItem('authUser');
    if (!user) {
        return null;
    } else {
        return JSON.parse(user);
    }
};

export { APIClient, setAuthorization, getLoggedinUser, redirectEmitter };
